import { CacheProperties } from "axios-cache-interceptor";
import { useMemo } from "react";
import MyEmoryContact from "../../../../models/salesforce/MyEmoryContact";
import { BaseService } from "../../../shared/src/services";
import { getDefaultAxiosInstance } from "../../../shared/src/services/BaseService/AxiosService";

class EUFinanceContactService extends BaseService {
  constructor() {
    super(getDefaultAxiosInstance(), "/api/myemory/v0/eufinance/contacts");
  }

  public async getMe(
    cache?: false | Partial<CacheProperties<MyEmoryContact, unknown>>
  ): Promise<MyEmoryContact> {
    const response = await super.get<MyEmoryContact>({
      url: this.getPath("me"),
      config: { cache },
    });
    return response?.data || {};
  }
}

export default EUFinanceContactService;

export const useEUFinanceContactService = (): EUFinanceContactService =>
  useMemo(() => new EUFinanceContactService(), []);
